module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external "ng2-alfresco-documentlist"
// module id = 3
// module chunks = 0